/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreProfileImageRequest } from './StoreProfileImageRequest';
import {
    StoreProfileImageRequestFromJSON,
    StoreProfileImageRequestFromJSONTyped,
    StoreProfileImageRequestToJSON,
    StoreProfileImageRequestToJSONTyped,
} from './StoreProfileImageRequest';

/**
 * 
 * @export
 * @interface StoreProfileImagesRequest
 */
export interface StoreProfileImagesRequest {
    /**
     * 
     * @type {StoreProfileImageRequest}
     * @memberof StoreProfileImagesRequest
     */
    header?: StoreProfileImageRequest;
    /**
     * 
     * @type {StoreProfileImageRequest}
     * @memberof StoreProfileImagesRequest
     */
    brand?: StoreProfileImageRequest;
    /**
     * 
     * @type {Array<StoreProfileImageRequest>}
     * @memberof StoreProfileImagesRequest
     */
    store?: Array<StoreProfileImageRequest>;
}

/**
 * Check if a given object implements the StoreProfileImagesRequest interface.
 */
export function instanceOfStoreProfileImagesRequest(value: object): value is StoreProfileImagesRequest {
    return true;
}

export function StoreProfileImagesRequestFromJSON(json: any): StoreProfileImagesRequest {
    return StoreProfileImagesRequestFromJSONTyped(json, false);
}

export function StoreProfileImagesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileImagesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'header': json['header'] == null ? undefined : StoreProfileImageRequestFromJSON(json['header']),
        'brand': json['brand'] == null ? undefined : StoreProfileImageRequestFromJSON(json['brand']),
        'store': json['store'] == null ? undefined : ((json['store'] as Array<any>).map(StoreProfileImageRequestFromJSON)),
    };
}

export function StoreProfileImagesRequestToJSON(json: any): StoreProfileImagesRequest {
    return StoreProfileImagesRequestToJSONTyped(json, false);
}

export function StoreProfileImagesRequestToJSONTyped(value?: StoreProfileImagesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': StoreProfileImageRequestToJSON(value['header']),
        'brand': StoreProfileImageRequestToJSON(value['brand']),
        'store': value['store'] == null ? undefined : ((value['store'] as Array<any>).map(StoreProfileImageRequestToJSON)),
    };
}

